// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 541) return "static/chunks/4cfcd194-706bae7312e34578.js";
	if (chunkId === 966) return "static/chunks/966-18eabe61686d819a.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"cfb1a57ca001a849","244":"6d06ea73012503f2","319":"0cbc2894a3f1b950","340":"378e526284645aa9","367":"2ceaa5a630c58634","639":"f36e198d30c766b4","748":"13b3a6bca4ae103c"}[chunkId] + ".js";
};